<template>
  <div>
    <md-button
      class="md-primary md-outlined-button prompt-button"
      :disabled="readonly"
      @click="openDialog"
    >
      <md-icon>
        {{ promptContents ? 'autorenew' : 'add' }}
      </md-icon>
      {{ promptContents ? 'Replace' : '' }} {{ buttonLabel }}
    </md-button>

    <md-dialog
      v-if="state.showPromptDialog"
      :md-active.sync="state.showPromptDialog"
      :md-fullscreen="false"
      class="prompt-dialog gray-3 bg"
    >
      <section-title>{{ title }}</section-title>
      <prompt-selector
        :prompts="state.sortedPrompts"
        @preview="previewPrompt"
      />
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="closeDialog"
        >
          Cancel
        </md-button>
        <md-button
          class="md-raised md-primary"
          :disabled="!state.previewedPrompt"
          @click="replacePrompt"
        >
          {{ promptContents ? 'Replace' : 'Add' }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import PromptSelector from '../../common/PromptSelector/PromptSelector.vue';
import SectionTitle from '../../common/SectionTitle';

export default {
  name: 'prompt-dialog',
  components: {
    PromptSelector,
    SectionTitle,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    promptContents: {
      type: String,
      default: null,
    },
    prompts: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      state: {
        showPromptDialog: false,
        previewedPrompt: null,
      }
    };
  },
  created() {
    this.state.sortedPrompts = this.prompts;
    this.state.sortedPrompts.sort((a, b) => a.name.en.localeCompare(b.name.en));
  },
  methods: {
    openDialog() {
      this.state.showPromptDialog = true;
    },
    closeDialog() {
      this.state.showPromptDialog = false;
    },
    updatePrompt(markup, content) {
      this.$emit('update', { markup, content });
    },
    replacePrompt() {
      if (this.state.previewedPrompt) {
        const markup = this.state.previewedPrompt.value.markup.en;
        const content = this.state.previewedPrompt.value.content.en;
        this.updatePrompt(markup, content);
        this.closeDialog();
      }
    },
    previewPrompt(prompt) {
      this.state.previewedPrompt = prompt;
    },
  },
}
</script>

<style scoped>
.prompt-dialog {
  padding: 20px 35px;
  overflow: auto;
}

.prompt-button {
  margin-right: 0;
}

@media (max-width: 599px) {
  .prompt-dialog {
    width: 400px;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .prompt-dialog {
    width: 600px;
  }
}

@media (min-width: 960px) {
  .prompt-dialog {
    width: 800px;
  }
}
</style>